import { Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { PageShell, Section, SectionLabel, Heading, Card, CardHeader, RowList, Row, Badge } from '../../components/elevation';
import { METHOD_PHASES, TOOLBOX_ENTRIES, getToolboxDefinition, type DegapPhase } from '../../lib/method/content';

const PHASE_GROUPS: DegapPhase[] = ['gather', 'arrange', 'prioritize'];

export default function ToolboxPage() {
  return (
    <PageShell>
      <Section>
        <Link
          to="/elevation/method"
          className="inline-flex items-center gap-1 text-sm text-charcoal-500 hover:text-charcoal-700 dark:text-charcoal-400 dark:hover:text-charcoal-200 mb-4"
        >
          <ArrowLeft className="h-3.5 w-3.5" /> The Method
        </Link>
        <SectionLabel>The Method</SectionLabel>
        <Heading as="h1" size="xl" className="mb-4">
          The technique toolbox
        </Heading>
        <p className="text-charcoal-700 dark:text-charcoal-300 max-w-3xl leading-relaxed">
          Named techniques from the book, each with a working tool in this app. Grouped by the
          DEGAP phase they're typically used in — Arrange and Prioritize lean on structured
          comparison and scoring; Gather leans on techniques that surface options in the first
          place.
        </p>
      </Section>

      {PHASE_GROUPS.map((phase) => {
        const phaseInfo = METHOD_PHASES.find((p) => p.phase === phase)!;
        const entries = TOOLBOX_ENTRIES.filter((t) => t.phase === phase);
        return (
          <Section key={phase}>
            <Card flush>
              <CardHeader
                label={`${phaseInfo.order}. ${phaseInfo.title.toUpperCase()}`}
                title={`Used during ${phaseInfo.title}`}
                count={entries.length}
              />
              <RowList>
                {entries.map((tool) => (
                  <Row key={tool.term}>
                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-charcoal-900 dark:text-charcoal-50">
                        {tool.term}
                      </div>
                      <p className="text-xs text-charcoal-500 dark:text-charcoal-400 mt-0.5">
                        {getToolboxDefinition(tool.term)}
                      </p>
                    </div>
                    <Link
                      to={tool.path}
                      className="shrink-0 inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium border border-charcoal-300 dark:border-charcoal-600 text-charcoal-700 dark:text-charcoal-200 hover:bg-[var(--hover-tint)] transition-colors"
                    >
                      Try it <ExternalLink className="h-3 w-3" />
                    </Link>
                  </Row>
                ))}
              </RowList>
            </Card>
          </Section>
        );
      })}

      <Section className="mb-0">
        <Badge variant="outline">
          <Link to="/elevation/glossary" className="hover:text-primary-600">
            Full glossary →
          </Link>
        </Badge>
      </Section>
    </PageShell>
  );
}
